import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import LoginModal from "../components/LoginModal";
import FooterCaixaBank from "../components/FooterCaixaBank";
import CaixaLogo from "../components/CaixaLogo";

// Images professionnelles pour desktop : personnes souriantes avec téléphone
const LEFT_IMAGE = "https://images.unsplash.com/photo-1595986630530-969786b19b4d?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"; // Femme souriante avec téléphone
const RIGHT_IMAGE = "https://images.unsplash.com/photo-1758598497476-c4a474397d9e?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"; // Homme souriant avec téléphone

const LoginPage = () => {
  const [loginOpen, setLoginOpen] = useState(true);
  const { user, initializing } = useAuth();

  // Utilisateur déjà connecté qui arrive sur "/" → on le renvoie vers son espace
  if (!initializing && user) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
  }

  return (
    <>
      {/* ===== MOBILE VIEW (< md) ===== */}
      <div className="md:hidden min-h-screen flex flex-col bg-white">
        {/* Modal de connexion */}
        <div className="flex-1 flex items-center justify-center p-4">
          <LoginModal 
            open={loginOpen} 
            onOpenChange={setLoginOpen} 
            hideCloseButton={true}
            standalone={true}
          />
        </div>
        
        {/* Footer en bas sur mobile - toujours visible */}
        <div className="mt-auto">
          <FooterCaixaBank />
        </div>
      </div>

      {/* ===== DESKTOP VIEW (>= md) ===== */}
      <div className="hidden md:block min-h-screen relative">
        {/* Fond avec images sur les côtés */}
        <div className="fixed inset-0 bg-slate-50">
          {/* Image gauche - Femme souriante avec téléphone */}
          <div className="absolute left-0 top-0 bottom-0 w-[40%]">
            <img
              src={LEFT_IMAGE}
              alt=""
              className="w-full h-full object-cover"
              loading="eager"
            />
            {/* Gradient pour fondre avec le centre */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-slate-50" />
          </div>
          
          {/* Image droite - Homme souriant avec téléphone */}
          <div className="absolute right-0 top-0 bottom-0 w-[40%]">
            <img
              src={RIGHT_IMAGE}
              alt=""
              className="w-full h-full object-cover"
              loading="eager"
            />
            {/* Gradient pour fondre avec le centre */}
            <div className="absolute inset-0 bg-gradient-to-l from-transparent via-transparent to-slate-50" />
          </div>
        </div>

        {/* Contenu par-dessus les images de fond */}
        <div className="relative z-10 min-h-screen flex flex-col">
          {/* Logo en haut à gauche */}
          <div className="absolute top-8 left-8 z-20">
            <CaixaLogo size={50} variant="default" />
          </div>

          {/* Contenu principal - Modal centré */}
          <div className="flex-1 flex items-center justify-center px-4 py-12">
            <LoginModal 
              open={loginOpen} 
              onOpenChange={setLoginOpen} 
              hideCloseButton={true}
              standalone={true}
            />
          </div>
          
          {/* Footer en bas sur desktop */}
          <FooterCaixaBank />
        </div>
      </div>
    </>
  );
};

export default LoginPage;
